import { render, staticRenderFns } from "./BackToLogin.vue?vue&type=template&id=4c3fc0a9&scoped=true&"
import script from "./BackToLogin.vue?vue&type=script&lang=js&"
export * from "./BackToLogin.vue?vue&type=script&lang=js&"
import style0 from "./BackToLogin.vue?vue&type=style&index=0&id=4c3fc0a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3fc0a9",
  null
  
)

export default component.exports